import React from "react";
import { Link } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
    const { wishlist } = useCart();
    return (
        <div className="max-w-[1400px] mx-auto px-4 md:px-10 py-10" data-testid="wishlist-page">
            <h1 className="font-display text-5xl md:text-7xl tracking-tighter mb-8">Wishlist</h1>
            {wishlist.items.length === 0 ? (
                <div className="border-2 border-black p-16 text-center">
                    <p className="font-mono text-sm mb-4">You haven't saved anything yet.</p>
                    <Link to="/shop" className="inline-block bg-black text-white px-6 py-3 font-mono uppercase text-xs tracking-widest">Browse Shop</Link>
                </div>
            ) : (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
                    {wishlist.items.map(p => <ProductCard key={p.id} product={p} />)}
                </div>
            )}
        </div>
    );
}
